import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-domain-device",
  "use": "app-icon-domain-device-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"app-icon-domain-device\"><g data-name=\"icon device32\" fill=\"#3dcca6\"><path fill-opacity=\".25\" d=\"M2 11h28v10H2z\" /><path d=\"M2 9h28a2 2 0 012 2v10a2 2 0 01-2 2H2a2 2 0 01-2-2V11a2 2 0 012-2zm1 2a1 1 0 00-1 1v8a1 1 0 001 1h26a1 1 0 001-1v-8a1 1 0 00-1-1zm1 4h2v2H4zm4 0a50.5 50.5 0 0120 0v2a50.5 50.5 0 00-20 0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol